import { render } from "./BrandLoves.vue?vue&type=template&id=f91b53ca&scoped=true"
import script from "./BrandLoves.vue?vue&type=script&lang=js"
export * from "./BrandLoves.vue?vue&type=script&lang=js"

import "./BrandLoves.vue?vue&type=style&index=0&id=f91b53ca&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f91b53ca"]])

export default __exports__